"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const styled_components_1 = require("styled-components");
const remark = require("remark");
const remarkFrontmatter = require("remark-frontmatter");
const remarkEmoji = require("remark-gemoji-to-emoji");
const remarkCustomBlocks = require("remark-custom-blocks");
const remark_video_1 = require("./remark-video");
const remarkRehype = require("remark-rehype");
const rehypeReact = require("rehype-react");
const rehypeSanitize = require("rehype-sanitize");
const sanitize_1 = require("./sanitize");
const Handlers = require("./handlers");
const M = require("./markdown-components");
var markdown_components_1 = require("./markdown-components");
exports.MarkdownList = markdown_components_1.MarkdownList;
exports.MarkdownItem = markdown_components_1.MarkdownItem;
exports.MarkdownLink = markdown_components_1.MarkdownLink;
exports.MarkdownWidgetSrc = React.createContext('');
exports.MarkdownWidgetState = React.createContext({});
class Markdown extends React.Component {
    constructor() {
        super(...arguments);
        this.processor = remark()
            .use(remarkFrontmatter)
            .use(remark_video_1.remarkVideo)
            .use(remarkCustomBlocks, {
            details: {
                title: "optional",
                details: true
            },
            grid: {
                title: "optional"
            },
            ["grid-column"]: {
                title: "required"
            }
        })
            .use(remarkEmoji)
            .use(remarkRehype, {
            handlers: {
                gridCustomBlock: Handlers.gridHandler,
                video: Handlers.videoHandler
            }
        })
            .use(rehypeSanitize, sanitize_1.sanitize)
            .use(rehypeReact, {
            createElement: React.createElement,
            components: {
                a: M.MarkdownLink,
                div: M.MarkdownDiv,
                blockquote: M.MarkdownBlockquote,
                code: M.MarkdownCode,
                h1: prop({ order: 1, linkable: true })(M.MarkdownHeadline),
                h2: prop({ order: 2, linkable: true })(M.MarkdownHeadline),
                h3: prop({ order: 3, linkable: true })(M.MarkdownHeadline),
                h4: prop({ order: 4 })(M.MarkdownHeadline),
                h5: prop({ order: 4 })(M.MarkdownHeadline),
                h6: prop({ order: 4 })(M.MarkdownHeadline),
                hr: M.MarkdownHr,
                img: M.MarkdownImage,
                li: M.MarkdownItem,
                p: M.MarkdownCopy,
                pre: M.MarkdownPre,
                ul: is("ul")(M.MarkdownList),
                ol: is("ol")(M.MarkdownList),
                details: M.MarkdownDetails,
                "x-grid": (props) => React.createElement(M.MarkdownDiv, { grid: true }, props.children),
                "x-grid-column": M.MarkdownDiv,
                "x-video": M.MarkdownVideo
            }
        });
    }
    render() {
        const { props } = this;
        const elements = this.processor.processSync(props.source).contents;
        const context = { widgetState: this.props.widgetState, widgetSrc: this.props.widgetSrc };
        return (React.createElement(StyledMarkdown, { className: props.className },
            React.createElement(exports.MarkdownWidgetSrc.Provider, { value: this.props.widgetSrc },
                React.createElement(exports.MarkdownWidgetState.Provider, { value: this.props.widgetState }, props.source && elements))));
    }
}
exports.Markdown = Markdown;
const StyledMarkdown = styled_components_1.default.div `
  & table {
    text-align: left;
    display: block;
    width: 100%;
    overflow: auto;
    margin: 0 0 16px 0;
    border-spacing: 0;
    border-collapse: collapse;
    font-size: 18px;
    line-height: 24px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial,
      sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  }
  & tr {
    color: ${props => props.theme.colors.color};
    border-top: 1px solid ${props => props.theme.colors.border};
    background: transparent;
  }
  & tbody tr:nth-child(odd) {
    background: ${props => props.theme.colors.backgroundTertiary};
  }
  & th {
    font-weight: 600;
  }
  & th,
  & td {
    padding: 20px 16px;
    border: 1px solid ${props => props.theme.colors.border};
    vertical-align: top;
  }
`;
function is(is) {
    return Component => props => React.createElement(Component, Object.assign({ as: is }, props));
}
function prop(p) {
    return Component => props => React.createElement(Component, Object.assign({}, props, p));
}
function getLanguagePayload({ children }) {
    const [child] = children;
    if (!child) {
        return [];
    }
    const className = child.props.className;
    if (!className) {
        return [];
    }
    return className.split(" ").map(n => n.replace("language-", ""));
}
//# sourceMappingURL=markdown.js.map